/**
 * Type guard to check if code is running in browser environment
 */
const isBrowser = (): boolean => {
  return typeof window !== 'undefined';
};

/**
 * Saves the application state to `localStorage`.
 * Only attempts to save if running in browser environment.
 *
 * @param {any} state - The application state to save. It should be serializable to JSON.
 * @returns {void}
 */
export const saveState = (state: any): void => {
  if (!isBrowser()) {
    return;
  }

  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('reduxState', serializedState);
  } catch (error) {
    // console.error('Error saving state to localStorage:', error);
  }
};

/**
 * Loads the application state from `localStorage`.
 * Returns undefined when running server-side or if no state exists.
 *
 * @returns {any | undefined} - The parsed state object if found, or `undefined`
 *                             if no state is found or an error occurs.
 */
export const loadState = (): any | undefined => {
  if (!isBrowser()) {
    return undefined;
  }

  try {
    const serializedState = localStorage.getItem('reduxState');
    if (!serializedState) return undefined;
    return JSON.parse(serializedState);
  } catch (error) {
    // console.error('Error loading state from localStorage:', error);
    return undefined;
  }
};
